const INITIAL_STATE = {
  motivos: { data: [] },
  categorias: {data: []},
  motivoSelectOption: [],
  reservasMotivos: []
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'MOTIVO_GRUPO_FETCH':
      return { ...state, motivos: action.payload }
    case 'MOTIVOS_SELECT_OPTIONS':
      return { ...state, motivoSelectOption: action.payload }
    case 'MOTIVOS_FETCH':
      return { ...state, reservasMotivos: action.payload }
    case 'RESERVAS_MOTIVOS_CATEGORIAS':
      return { ...state, categorias: action.payload }
    default:
      return state
  }
}